import * as angular from 'angular';
import { downgradeComponent } from '@angular/upgrade/static';

import { QueryComponent } from '@mode/switch-views/feature-query';
import { ExportDatasetViewComponent } from '@mode/switch-views/ui';

export const DowngradedSwitchViewsFeatureQueryModule = angular
  .module('downgraded-switch-views-feature-query', [])
  .directive('modeQuery', downgradeComponent({ component: QueryComponent }))
  .directive('modeExportDatasetView', downgradeComponent({ component: ExportDatasetViewComponent })).name;
